var exports = {
  "QU": "CopilotHeaderV2__Ub3s3b",
  "a": "CopilotHeaderV2__sidebarToggle__jbEAmW",
  "Hv": "CopilotHeaderV2__content__CNid3C",
  "C2": "CopilotHeaderV2__link__kxD3G8",
};

module.exports = exports;
